import React from 'react';
import ModuleCard from './ModuleCard';

/**
 * Grid do hub: Contratos em destaque + demais módulos.
 */
export default function ModuleGrid({
  modules,
  loading,
  skeletonCount = 6,
  stats,
  onOpenMap,
  onNavigate,
}) {
  if (loading) {
    return (
      <div className="module-hub-grid" role="status" aria-label="Carregando módulos">
        <ModuleCard key="skeleton-featured" skeleton featured />
        {Array.from({ length: Math.max(0, skeletonCount - 1) }, (_, i) => (
          <ModuleCard key={`skeleton-${i}`} skeleton />
        ))}
      </div>
    );
  }

  if (!modules || modules.length === 0) {
    return null;
  }

  const ordered = [...modules].sort((a, b) => {
    if (a.id === 'contratos') return -1;
    if (b.id === 'contratos') return 1;
    return 0;
  });

  return (
    <div className="module-hub-grid">
      {ordered.map((mod) => (
        <ModuleCard
          key={mod.id}
          module={mod}
          featured={mod.id === 'contratos'}
          stats={mod.id === 'contratos' ? stats : undefined}
          onOpenMap={onOpenMap}
          onNavigate={onNavigate}
        />
      ))}
    </div>
  );
}
